import Tab from '@mui/material/Tab';
import React from 'react';
import { Link } from 'react-router';
import { tabStyle } from 'src/common/components/AppLayout/AppLayout.styles';
import { TabsContainer } from 'src/common/components/AppLayout/Components/TabsContainer';
import { a11yTabProps } from 'src/common/components/AppLayout/Components/utils';
import { Routes } from 'src/Routes.constants';
import { useSimProfilesUrlFromFilters } from '../hooks/useSimProfilesUrlFromFilters';

export const SimProfilesTabLayout = ({
  children,
  additionalTopMargin = 0,
}: {
  children: React.ReactNode;
  firstTabHighlited?: boolean;
  additionalTopMargin?: number;
}) => {
  const simProfileUrl = useSimProfilesUrlFromFilters();

  return (
    <TabsContainer content={children} additionalTopMargin={additionalTopMargin}>
      <Tab
        sx={tabStyle}
        value={Routes.simInventory}
        label="SIM"
        component={Link}
        to={simProfileUrl}
        {...a11yTabProps('SIM')}
      />
    </TabsContainer>
  );
};
